/* eslint-disable  */
import { Checkbox, FormGroup, FormControlLabel } from '@material-ui/core';
import {
  brandList,
  otherCheckedB,
  otherSelectedBrand,
  ownCheckedB,
  ownSelectedBrand,
  setOtherCheckedBrandList,
  setOwnCheckedBrandList
} from 'feactures/brand/brandSlice';
import { currentchannel } from 'feactures/channel/channelSlice';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const BrandSelectCheckbox = (props) => {
  const { section } = props;
  const dispatch = useDispatch();
  const channel = useSelector(currentchannel);
  const allBrandList = useSelector(brandList);
  const selectOwnBrand = useSelector(ownSelectedBrand);
  const checkedOtherBrand = useSelector(otherCheckedB);
  const selectOtherBrand = useSelector(otherSelectedBrand);
  const checkedOwnBrand = useSelector(ownCheckedB);
  let selectBrand = '';
  let checkedBrand = '';
  if (section == 'other') {
    selectBrand = selectOtherBrand;
    checkedBrand = checkedOtherBrand;
  } else {
    selectBrand = selectOwnBrand;
    checkedBrand = checkedOwnBrand;
  }
  let chBrandList = [];
  let current_channel_checked_brand = '';
  if (channel == 1) {
    chBrandList = allBrandList.amazon;
    current_channel_checked_brand = checkedBrand.amazon.brand;
  } else if (channel == 2) {
    chBrandList = allBrandList.rakuten;
    current_channel_checked_brand = checkedBrand.rakuten.brand;
  } else if (channel == 3) {
    chBrandList = allBrandList.yahoo;
    current_channel_checked_brand = checkedBrand.yahoo.brand;
  }

  const sanitizeBrandList = (list, checkedName) =>
    list
      // brand_name が null, undefined, 空文字, '0' の場合は除外
      .filter((item) => {
        const name = item?.brand_name;
        return (
          name !== null && name !== undefined && name !== '' && name !== '0'
        );
      })
      .map((item) => ({
        id: item.brand_id,
        brand: item.brand_name,
        isChecked: checkedName === item.brand_name
      }));

  const [checked, setChecked] = useState(
    sanitizeBrandList(chBrandList, current_channel_checked_brand)
  );

  useEffect(() => {
    if (channel == 1) {
      chBrandList = allBrandList.amazon;
    } else if (channel == 2) {
      chBrandList = allBrandList.rakuten;
    } else if (channel == 3) {
      chBrandList = allBrandList.yahoo;
    }
    setChecked(sanitizeBrandList(chBrandList, current_channel_checked_brand));
  }, [allBrandList]);

  useEffect(() => {
    setChecked(sanitizeBrandList(chBrandList, current_channel_checked_brand));
  }, [selectOwnBrand, checkedOwnBrand, selectOtherBrand, checkedOtherBrand]);

  const handleChange = (e, brand, id) => {
    if (e.target.checked) {
      if (section == 'own') {
        dispatch(
          setOwnCheckedBrandList({ channel, list: { brand: brand, id: id } })
        );
      } else {
        dispatch(
          setOtherCheckedBrandList({ channel, list: { brand: brand, id: id } })
        );
      }
    } else {
      if (section == 'own') {
        dispatch(setOwnCheckedBrandList({ channel, list: '' }));
      } else {
        dispatch(setOtherCheckedBrandList({ channel, list: '' }));
      }
    }
  };

  // チャンネルを変えて戻ってきてもチェックが入るようにする
  useEffect(() => {
    const updatedChecked = checked.map((elem) => {
      let isMatch = false;
      if (channel === 1) {
        isMatch = selectBrand.amazon.brand === elem.brand;
      } else if (channel === 2) {
        isMatch = selectBrand.rakuten.brand === elem.brand;
      } else if (channel === 3) {
        isMatch = selectBrand.yahoo.brand === elem.brand;
      }
      return {
        ...elem,
        isChecked: isMatch
      };
    });

    setChecked(updatedChecked);
  }, [channel]);

  return (
    <div>
      <FormGroup>
        {checked.map((item, index) => {
          return (
            <FormControlLabel
              key={item.id || item.brand}
              control={
                <Checkbox
                  checked={item.isChecked}
                  onChange={(e) => handleChange(e, item.brand, item.id)}
                  name={item.brand}
                />
              }
              label={item.brand}
            />
          );
        })}
      </FormGroup>
    </div>
  );
};

export default BrandSelectCheckbox;
